import styled, { css } from "styled-components";

import { INPUT_BUTTON_SIZE } from "uikit/constants";
import { elementOuterSpacingMixin } from "uikit/styles";

import {
  INPUT_BORDER_RADIUS,
  INPUT_FIXED_WIDTH_MAX,
  INPUT_FONT_SIZE,
  INPUT_LINE_HEIGHT,
  INPUT_PADDING,
} from "./constants";
import {
  IContainerProps,
  IInputBaseContainerProps,
  IInputBaseProps,
  ITextareaContainerProps,
} from "./types";

const textareaTextHeight = 24;
const resetInputStyles = css`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  line-height: inherit;
  width: 100%;
  height: 100%;
  resize: none;

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
const textMixin = css<IInputBaseProps>`
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ $size }) => INPUT_FONT_SIZE[$size || "medium"]};
  line-height: ${({ $size }) => INPUT_LINE_HEIGHT[$size || "medium"]};
`;
const sizeInputMixin = css<IInputBaseProps>`
  height: ${({ $size }) => INPUT_BUTTON_SIZE[$size || "medium"]};
  padding: ${({ $size }) => INPUT_PADDING[$size || "medium"]};
  width: inherit;
  max-width: inherit;
`;
const inputBaseMixin = css<IInputBaseContainerProps>`
  input,
  textarea {
    ${resetInputStyles};
    ${textMixin};
  }
  ${sizeInputMixin};
  ${elementOuterSpacingMixin};
  display: flex;
  align-items: center;
  border-radius: ${INPUT_BORDER_RADIUS};
  transition: border-color 0.3s;
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray["400"]};

  ${({ error }) =>
    error
      ? css`
          border-color: ${({ theme }) => theme.colors.colorsNew.error["500_main"]};
        `
      : css`
          &:hover {
            border-color: ${({ theme }) => theme.colors.colorsNew.gray["900"]};
          }
          &:focus-within {
            border-color: ${({ theme }) => theme.colors.colorsNew.blue.blue};
          }
        `}
`;

export const Container = styled.label<IContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: ${INPUT_FIXED_WIDTH_MAX};

  ${({ $isParentWidth }) =>
    $isParentWidth &&
    css`
      width: 100%;
      max-width: 100%;
    `}
`;
export const InputContainer = styled.div<IInputBaseContainerProps>`
  ${inputBaseMixin};
`;
export const TextareaContainer = styled.div<ITextareaContainerProps>`
  ${inputBaseMixin};

  min-height: ${({ rows }) => {
    if (!rows) return;
    const height = textareaTextHeight * rows;
    return `${height}px;`;
  }};
`;

export const InputBase = styled.input``;
export const TextareaBase = styled.textarea`
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray["400"]};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray["100"]};
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 16px;
    height: 16px;
    path {
      stroke: ${({ theme }) => theme.colors.colorsNew.error["500_main"]};
    }
  }
`;
